import { render } from "./ProductReservation.vue?vue&type=template&id=7a253ddc"
import script from "./ProductReservation.vue?vue&type=script&lang=js"
export * from "./ProductReservation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__